<template>
    <div class="content-box">
        <div class="title">{{ brandName }}</div>
        <div class="action-box">
            <div class="action-item" v-for="(item, index) in actionList" :key="index" @click="goAction(item.path)">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>
<script>
import { Mixins, Component, Watch } from "vue-property-decorator";
import loading from "@/mixins/loading";
@Component({ name: 'prescription-db-action' })
export default class actionList extends loading {

    merchantId = this.$route.query.merchantId || "";;
    brandName = this.$route.query.brandName || "";
    actionList = [
        { name: "编辑", path: "/merchantEdit" },
        { name: "产品分类管理", path: "/prescription-product-merchant-category" },
        { name: "产品库管理", path: "/prescription-product-merchant-list" },
        { name: "处方库", path: "/merchantDb" },
        { name: "中医大脑排版", path: "/merchantAppCompose" },
        { name: "小程序Banner", path: "/merchantBanner" },
        { name: "小程序配置", path: "/merchantMiniSetting" },
        { name: "百症调养配置", path: "/brand-symptoms" },
        { name: "检测类介绍说明配置", path: "/appBrandDescriptionSetting" },
        { name: "门店预约", path: "/merchant-booking" },
        { name: "报告配置", path: "/reportConfig" },
        { name: "数据大屏设置", path: "/smartScreenSetting" },
        { name: "智能评估配置", path: "/merchant-dialectic" },
    ]

    goAction(path) {
        this.$router.push({
            path,
            query: { merchantId: this.merchantId, brandName: this.brandName }
        }).catch((err) => {
            // NOTE: 忽略重复导航错误（点击目标路由与当前路由相同时触发）
            if (err.name !== 'NavigationDuplicated') {
                throw err
            }
        })
    }
}
</script>
<style lang="scss" scoped>
.content-box {
    background: #ffffff;
    padding: 25px;

    .title {
        font-size: 18px;
        color: #333333;
        font-weight: bold;
    }

    .action-box {
        // NOTE: 用 grid + gap 替代 flex + margin-right，避免固定 18% 宽度 + 固定 margin 导致卡片溢出白色区域
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
        gap: 25px;
        margin-top: 25px;

        .action-item {
            width: 100%;
            height: 150px;
            background: #f2f2f2;
            line-height: 150px;
            text-align: center;
            font-size: 15px;
            cursor: pointer;
        }
    }
}

</style>